export default __webpack_public_path__ + "static/media/splash-icon.e5261275.png";